<template>
  <div
    v-if="client"
    :class="[loaded ? 'bg-truegray-100' : 'bg-truegray-500']"
    class="min-h-screen lg:mr-44"
  >
    <div
      class="bg-expo_dblue hero-gradient lg:h-120 w-full relative z-10 text-white flex flex-col justify-center items-center overflow-y-visible space-y-6 bg-cover bg-no-repeat bg-center"
      :style="{ backgroundImage: 'url(/img/cw-magazine.jpg)' }"
    >
      <div
        class="max-w-3xl flex flex-col text-center z-10 px-12 lg:px-0 relative"
      >
        <h4 class="text-expo_red uppercase mb-4">Online Expo</h4>
        <h1 class="text-5xl">Exhibitor Latest News</h1>

        <p class="text-lg">
          Regularly updated articles from our exhibitors curated just for you
        </p>
      </div>
    </div>

    <!-- POST FEED AND PAGINATION -->
    <div class="p-16" :class="[loaded ? 'bg-truegray-100' : 'bg-truegray-500']">
      <div v-show="loaded" class="w-full mb-12">
        <router-link v-show="loaded" class="inline no-underline z-10" to="/">
          <span
            class="items-center justify-center uppercase cursor-pointer space-x-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 inline"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16l-4-4m0 0l4-4m-4 4h18"
              />
            </svg>
            <span>Back to Online Expo</span>
          </span>
        </router-link>
      </div>

      <div
        class="w-full text-gray-900 flex flex-col items-center justify-center"
      >
        <div
          class="transition-all duration-300 transform w-full max-w-7xl"
          :class="[
            loaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0',
          ]"
        >
          <div
            v-if="loaded"
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4"
          >
            <PostsCard
              v-for="(post, i) in posts"
              :id="post.id"
              :key="i"
              :ref="'posts-' + i"
              :post="post"
              expo="true"
            />
          </div>
        </div>

        <div
          v-if="!loaded"
          class="h-52 flex flex-col justify-center items-center w-full max-w-7xl"
        >
          <lottie :options="loadingAnimationOptions" />
          <span class="text-white text-center">Loading posts</span>
        </div>

        <p v-if="loaded && posts.length < 1" class="text-md">
          We could not find any posts...
        </p>

        <!-- PAGINATION -->
        <div
          v-if="pagination.previouspage || pagination.nextpage"
          class="flex justify-between items-center h-10 w-full max-w-7xl"
        >
          <span
            :disabled="!pagination.previouspage"
            :class="[
              !pagination.previouspage
                ? 'opacity-25 cursor-not-allowed'
                : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
            ]"
            class="text-gray-500"
            @click="getPosts(pagination.previouspage)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M11 17l-5-5m0 0l5-5m-5 5h12"
              />
            </svg>
          </span>
          <span class="text-center text-xs"
            >Page {{ pagination.current_page }} of
            {{ pagination.total_pages }}</span
          >
          <span
            :disabled="!pagination.nextpage"
            :class="[
              !pagination.nextpage
                ? 'opacity-25 cursor-not-allowed'
                : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
            ]"
            class="text-gray-500"
            @click="getPosts(pagination.nextpage)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PostsCard from '../../../shared/components/PostsCard.vue'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  components: {
    PostsCard,
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      loaded: false,
      posts: [],
      pagination: {
        current_page: null,
        total_pages: null,
        per_page: 9,
        next_page: null,
        previous_page: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null,
        nextpage: null,
        previouspage: null,
      },
    }
  },

  computed: {
    ...mapGetters({
      client: 'shared/getClient',
    }),
  },

  created() {
    if (this.client !== 'client2cloud') {
      this.$router.push('/')
    } // only allow Expo ( client 2 access for the /magazine template )
  },

  mounted() {
    this.getPosts()
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    },

    getPosts(getpage = null) {
      axios
        .post('/api/cloud-magazine-posts', {
          page: getpage,
          filter: { tags: [1, 2, 3] },
        })
        .then((response) => {
          let result = response.data
          if (result.success) {
            this.$set(this, 'posts', result.posts)
            this.$set(this, 'loaded', true)

            // pagination.total = total # of posts. / by per_page, + 1. Pagination doesnt show when not needed so +1 is never wrong on single page
            let total_pages =
              Math.floor(
                response.data.pagination.total /
                  response.data.pagination.per_page,
              ) + 1
            this.$set(
              this.pagination,
              'current_page',
              response.data.pagination.current_page,
            )
            this.$set(this.pagination, 'total_pages', total_pages)
            this.$set(
              this.pagination,
              'per_page',
              response.data.pagination.per_page,
            )
            this.$set(
              this.pagination,
              'last_page_url',
              response.data.pagination.last_page_url,
            )
            this.$set(
              this.pagination,
              'next_page_url',
              response.data.pagination.next_page_url,
            )
            this.$set(
              this.pagination,
              'prev_page_url',
              response.data.pagination.prev_page_url,
            )
            this.$set(
              this.pagination,
              'path',
              response.data.pagination.next_page_path,
            )

            let prev = null
            if (this.pagination.prev_page_url) {
              prev = this.pagination.prev_page_url.split('=')
              prev = prev[1]
            }

            let next = null
            if (this.pagination.next_page_url) {
              next = this.pagination.next_page_url.split('=')
              next = next[1]
            }

            this.$set(this.pagination, 'previouspage', prev)
            this.$set(this.pagination, 'nextpage', next)
          } else {
            //...
          }
        })
    },
  },
}
</script>

<style scoped>
.hero-gradient::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  height: 100%;
  background: rgb(1, 23, 47);
  opacity: 70%;
}
</style>
